export default __webpack_public_path__ + "static/media/hero-premium@3x.23a9a050.png";